export default __webpack_public_path__ + "static/media/replaceMatch.19f0994f.svg";